<template>
  <p
      v-if="expirationText"
      :class="[
        'branded-image-expiration',
        { ['branded-image-expiration__expires-soon']: this.expiresSoon },
        { ['branded-image-expiration__expires-today']: this.expiresToday }]">
    {{expirationText}}
  </p>
</template>

<script>
  import moment from 'moment-timezone'

  export default {
    props: {
      sendAtEnd: String,
    },

    name: 'AdExpirationWarning',

    data() {
      return {
        dateFormat: 'YYYY-MM-DD HH:mm',
        expiresSoonDate: moment().add(5, 'days').endOf('day').format(this.dateFormat),
        expiresTodayDate: moment().add(1, 'day').endOf('day').format(this.dateFormat),
      }
    },

    computed: {
      expirationText: function () {
        if (this.expiresToday) { return 'expires today' }
        if (this.expiresSoon) { return 'expires soon' }
      },

      expiresSoon: function () {
        return !this.expiresToday && this.isDateSameOrBefore(this.expiresSoonDate)
      },

      expiresToday: function () {
        return this.isDateSameOrBefore(this.expiresTodayDate)
      },
    },

    methods: {
      isDateSameOrBefore(dateToCompare) {
        if (!this.sendAtEnd || !dateToCompare) { return }
        return moment(this.sendAtEnd, this.dateFormat).isSameOrBefore(dateToCompare)
      }
    },
  }
</script>
